module.exports = __webpack_public_path__ + "static/media/LogicLever1_3_1.ffe0c792.png";